// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Residential Address Add Start ************************/
export const residentialMemberDetailsAdd = (verifyData: any) => {
	const data = {
		CreateResidentialDetailsToken: verifyData,
	};
	const url = `${API_URL}addResidentialDetails`;
	return makeApiCall(url, data);
};
/** ***************** Residential Address Add End ************************/
